import { onboardingHelper } from './onboardingHelper'

export function teacherDashboardHelper() {
    return {
        teacherSteps: [
            { 
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>YOUR DASHBOARD</h2>
                    <p>Use the dashboard to compare component averages year-over-year.</p>
                    <p>This can be helpful when preparing for planning conferences or tenure portfolios.</p>`
            },
            {   element: '#comp-average',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>YOUR DASHBOARD</h2>
                    <p>To better understand rating averages, click into an average to view all of the component evidence. Try it now!</p>`,
                tooltipClass: 'hide-skip' 
            },
            {   element: '.chart-container',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>YOUR DASHBOARD</h2>
                    <p>Use this graph to view your component averages year-over-year.</p>`,
                tooltipClass: 'hide-skip'
            },
            {   element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>YOUR DASHBOARD</h2>
                    <p>If you ever need a reminder, find the tutorial for each page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step' 
            }
        ],
        adminSteps: [
            {
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>TEACHER DASHBOARD</h2>
                    <p>Use the Teacher Dashboard to view and compare a teacher's component average over time.</p>`
            },
            {
                element: '#comp-average',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>TEACHER DASHBOARD</h2>
                    <p>Click into a score to view observation feedback by date on this component over the past three school years.</p>
                    <p>You can use this feature to answer questions about teacher practice and view the impact of feedback over time. Try it now!</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '.chart-container',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>TEACHER DASHBOARD</h2>
                    <p>Use this chart to view a comparison of this teacher's past component averages.</p>
                    <p>This can be a valuable resource in looking at year-over-year trends in teacher performance.</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneTeacherDashboardOnboarding') }
                    <h2>TEACHER DASHBOARD</h2>
                    <p>If you ever need a reminder, find the tutorial for each page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step'
            }
        ]
    }
}